import Swiper, { Pagination, Navigation, Autoplay } from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay]);
import MicroModal from 'micromodal';

export namespace flashcards {
	let setupSlider = () => {

		let productCarousels = document.querySelectorAll('.js-recipe-product-carousel');

		productCarousels.forEach((carousel, index) => {
			carousel.classList.add(`flashcard-carousel__swiper--${index}`);
			const swiper = new Swiper(`.flashcard-carousel__swiper--${index}`, {
				slidesPerView: 1,
				spaceBetween: 0,

				// Navigation arrows
				navigation: {
					nextEl: `.flashcard-carousel__swiper--${index} .swiper-button-next`,
					prevEl: `.flashcard-carousel__swiper--${index} .swiper-button-prev`,
				},

				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 80,
					},
					500: {
						slidesPerView: 2,
						spaceBetween: 20,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 40,
					},
					992: {
						slidesPerView: 4,
						spaceBetween: 40,
					}
				}
			});
		});
	}

	let setupModal = () => {
		let links = document.querySelectorAll('.js-flashcard-modal');

		links.forEach((link) => {
			link.addEventListener('click', (e) => {
				let imageUrl = link.getAttribute('data-imageUrl');
				let summary = link.getAttribute('data-summary');
				let description = link.getAttribute('data-description');

				let modalImage = document.querySelector('.modal__flashcard_image');
				modalImage.setAttribute('src', imageUrl);
				let modalSummary = document.querySelector('.modal__flashcard_summary');
				//modalSummary.setAttribute('src', summary);
				modalSummary.innerHTML = summary;
				let modalDescription = document.querySelector('.modal__flashcard_description');
				//modalDescription.setAttribute('src', description);
				modalDescription.innerHTML = description;
							
				MicroModal.show('modal-flashcard', {
					onShow: function () {
						let ModalCloseBtn = document.getElementById('ModalFlashcardClose');
						if(ModalCloseBtn){
							ModalCloseBtn.blur();
						}
					},
				});
				e.preventDefault();
			});
		});
		
		
	}
	export const init = () => {
		setupSlider();
		setupModal();
	}
}

document.addEventListener('DOMContentLoaded', flashcards.init);
